import { v3Url } from "@/services/api/apiPrefix";

const apiUrl = v3Url("/user/auth");

export function userAuthenticate(store, email, password) {
  return store
    .dispatch("auth/login")
    .then(() => {
      const token = store.getters["auth/getToken"];

      return fetch(apiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorizationIntegrator: `${token}`,
        },
        body: JSON.stringify({
          email,
          password,
        }),
      });
    })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Usuário ou senha incorretos.");
      }

      return response.json();
    })
    .then((data) => {
      return data;
    })
    .catch((error) => {
      ("Login failed:", error.response ? error.response.data : error.message);
      throw error;
    });
}

export default {
  userAuthenticate,
};
